import { Component, Output, Input, EventEmitter, OnInit, HostListener } from '@angular/core';
import { Reference } from '../../tools/api.service';
import { Sort } from '@angular/material/sort';
import { SearchCrit } from 'src/app/entities/searchCrit';
import { HeaderService } from 'src/app/tools/header.service';
import { ColonneSort } from '../../entities/ColonneSort'; 

@Component({
  selector: 'variantelist',
  templateUrl: './variante-list.component.html',
  styleUrls: ['./variante-list.component.scss']
})

export class VariantListComponent implements OnInit {
  @Input() variants: Reference[];
  @Input() searchCrit: SearchCrit;
  @Output() reference = new EventEmitter<Reference>();

  displayedColumns = ["manufacturer", "code", "designation", "dateFrom", "dateTo", "shader", "techno", "popularite", "ssCouche"];
  techno: boolean = false;

  //directionSort: string[] = ["", "", "", "", "", "", "", "", "", ""];
  //sortActive: number[] = [0,0,0,0,0,0,0,0,0,0];
  //colonneSort: string[] = ["","","","","","","","","",""];

  listMultiSort: ColonneSort[] = [];

  sortedResults: Reference[];
  @HostListener('window:popstate', ['$event'])
  onPopState(event: any) {
    this.headerService.changeBack(true);
  }
  constructor(private headerService: HeaderService) { }
  
  ngOnInit(): void {
    window.onpopstate = function () {
    };

    if (this.searchCrit.searchWorld)
      this.displayedColumns.push("region");

    this.sortedResults = this.variants.slice();
    if (this.sortedResults.length == 1) 
      setTimeout(() => { this.SelectReference(this.sortedResults[0]); }, 200);

    if (this.variants[0].rvb != null) {
      const color = "#".concat('', this.variants[0].rvb);
      document.getElementById('rectColor').style.backgroundColor = color;
      document.getElementById('rectColor').style.display = "block"
    }
    else {
      document.getElementById('rectColor').style.display="none"
    }
  }

  //sortReferences(sort: Sort) {
  //  const isAsc = sort.direction == 'asc';
  //  const data = this.variants.slice();
  //  if (!sort.active || sort.direction === '') {
  //    this.sortedResults = data;
  //    return;
  //  }
  //  this.sortedResults = data.sort((a, b) => {
  //    switch (sort.active) {
  //      case "manufacturer":
  //        if (a.manufacturer == b.manufacturer) return 0;
  //        return (a.manufacturer < b.manufacturer ? -1 : 1) * (isAsc ? 1 : -1);
  //      case "code":
  //        if (a.code == b.code) return 0;
  //        return (a.code < b.code ? -1 : 1) * (isAsc ? 1 : -1);
  //      case "designation":
  //        if (a.designation == b.designation) return 0;
  //        return (a.designation < b.designation ? -1 : 1) * (isAsc ? 1 : -1);
  //      case "dateFrom":
  //        if (a.dateFrom == b.dateFrom) return 0;
  //        return (a.dateFrom < b.dateFrom ? -1 : 1) * (isAsc ? 1 : -1);
  //      case "dateTo":
  //        if (a.dateTo == b.dateTo) return 0;
  //        return (a.dateTo < b.dateTo ? -1 : 1) * (isAsc ? 1 : -1);
  //      case "formule":
  //        if (a.formuleNum == b.formuleNum) return 0;
  //        return (a.formuleNum < b.formuleNum ? -1 : 1) * (isAsc ? 1 : -1);
  //      case "shader":
  //        if (a.shadeGuideNum == b.shadeGuideNum) return 0;
  //        return (a.shadeGuideNum < b.shadeGuideNum? -1 : 1) * (isAsc ? 1 : -1);
  //      case "techno":
  //        if (a.technology == b.technology) return 0;
  //        return (a.technology < b.technology ? -1 : 1) * (isAsc ? 1 : -1);
  //      case "popularite":
  //        if (a.popularite == b.popularite) return 0;
  //        return (a.popularite.replace("< ", "") < b.popularite.replace("< ", "") ? -1 : 1) * (isAsc ? 1 : -1);
  //      case "ssCouche":
  //        if (a.ssCouche == b.ssCouche) return 0;
  //        return (a.ssCouche < b.ssCouche ? -1 : 1) * (isAsc ? 1 : -1);
  //      case "region":
  //        if (a.region == b.region) return 0;
  //        return (a.region < b.region ? -1 : 1) * (isAsc ? 1 : -1);
  //    }
  //  });
  //}

  SelectReference(ref: Reference) {
    this.reference.emit(ref);
  }

  nextListMultiSort(designationColonne: string) {
    var indexColonne = this.listMultiSort.findIndex(x => x.nameColonneSort == designationColonne);
    if (indexColonne > -1) {
      if (this.listMultiSort[indexColonne].directionSort == "asc") {
        this.listMultiSort[indexColonne].directionSort = "desc";
      } else {
        this.listMultiSort.splice(indexColonne, 1);
      }
    } else {
      var col = new ColonneSort();
      col.directionSort = "asc";
      col.nameColonneSort = designationColonne;
      this.listMultiSort.push(col);
    }
  }

  multiSortManuel(designationColonne: string) {
    this.nextListMultiSort(designationColonne);
    this.multiSortData();
  }

  multiSortData() {
    const data = this.variants.slice();
    if (this.listMultiSort.length == 0) {
      this.sortedResults = data;
      return;
    }

    this.sortedResults = data.sort((a, b) => {
      return this.recursiveMultiSortData(a, b, 0);
    });
  }

  recursiveMultiSortData(a: Reference, b: Reference, index: number) {
    var res = 0;
    this.listMultiSort.forEach(function (value) {
      if (value.nameColonneSort != "popularite") {
        if (a[value.nameColonneSort] < b[value.nameColonneSort]) { res = -1 * (value.directionSort == "asc" ? 1 : -1); return; }
        if (a[value.nameColonneSort] > b[value.nameColonneSort]) { res = 1 * (value.directionSort == "asc" ? 1 : -1); return; }
      } else {
        if (parseInt(a[value.nameColonneSort].replace("< ", "")) < parseInt(b[value.nameColonneSort].replace("< ", ""))) { res = -1 * (value.directionSort == "asc" ? 1 : -1); return; }
        if (parseInt(a[value.nameColonneSort].replace("< ", "")) > parseInt(b[value.nameColonneSort].replace("< ", ""))) { res = 1 * (value.directionSort == "asc" ? 1 : -1); return; }
      }
    });
    return res;
  }

  checkIfArrowUp(designationColonne: string) {
    var index = this.listMultiSort.findIndex(x => x.nameColonneSort == designationColonne);
    if (index == -1) return false;
    return this.listMultiSort[index].directionSort == 'asc'
  }
  checkIfArrowDown(designationColonne: string) {
    var index = this.listMultiSort.findIndex(x => x.nameColonneSort == designationColonne);
    if (index == -1) return false;
    return this.listMultiSort[index].directionSort == 'desc'
  }
  checkPositionArray(designationColonne: string) {
    return this.listMultiSort.findIndex(x => x.nameColonneSort == designationColonne);
  }

  //nextSortActive(indexColonne: number, designationColonne: string) {
  //  if (this.sortActive[indexColonne] == 0) {
  //    this.sortActive[indexColonne] = 1;
  //    this.directionSort[indexColonne] = "asc";
  //    this.colonneSort[indexColonne] = designationColonne;
  //  } else if (this.sortActive[indexColonne] == 1) {
  //    this.sortActive[indexColonne] = 2;
  //    this.directionSort[indexColonne] = "desc";
  //    this.colonneSort[indexColonne] = designationColonne;
  //  } else {
  //    this.sortActive[indexColonne] = 0;
  //    this.directionSort[indexColonne] = "";
  //    this.colonneSort[indexColonne] = "";
  //  }
  //}

  //sortManuel(indexColonne: number, designationColonne: string) {

  //  //if (designationColonne == "technology" && this.sortActive[indexColonne] != 2) {
  //  //  this.techno = true;
  //  //} else {
  //  //  this.techno = false;
  //  //}
  //  this.nextSortActive(indexColonne, designationColonne);
  //  this.sortData(indexColonne, designationColonne);
  //}

  //sortData(indexColonne: number, designationColonne: string) {
  //  /* ---------------------------------------------------------------------------------------------------- */console.log("/*---------------------------------*/");
  //  /* ---------------------------------------------------------------------------------------------------- */console.log("function sortData");

  //  const data = this.variants.slice();

  //  var resetTable = true; 
  //  this.sortActive.forEach(function (value) {
  //    if (value != 0) {
  //      resetTable = false;
  //    }
  //  });
  //  this.directionSort.forEach(function (value) {
  //    if (value != '') {
  //      resetTable = false;
  //    }
  //  });
  //  if (resetTable) {
  //    this.sortedResults = data;
  //    return;
  //  }

  //  //if (indexColonne != 2 && indexColonne != 6 && indexColonne != 9) {

  //  //} else {
  //  //  this.techno = false;
  //  //  this.directionSort = ["", "", "", "", "", "", "", "", "", ""];
  //  //  this.sortActive = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  //  //  this.colonneSort = ["", "", "", "", "", "", "", "", "", ""];
  //  //  this.nextSortActive(indexColonne, designationColonne);
  //  //}

  //  //this.techno = true;

  //  //if (this.techno) {
  //  //  if (indexColonne == 2 || indexColonne == 6 || indexColonne == 9) {

  //  //  } else {
  //  //    this.techno = false;
  //  //    this.directionSort = ["", "", "", "", "", "", "", "", "", ""];
  //  //    this.sortActive = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  //  //    this.colonneSort = ["", "", "", "", "", "", "", "", "", ""];
  //  //    //this.nextSortActive(indexColonne, designationColonne);
  //  //  }
  //  //}


  //  const isAsc = this.directionSort[indexColonne] == 'asc';
  //  this.sortedResults = data.sort((a, b) => {
  //    if (a[designationColonne] == b[designationColonne]) return 0;
  //    if (designationColonne == "popularite") {
  //      return (parseInt(a.popularite.replace("< ", "")) < parseInt(b.popularite.replace("< ", "")) ? -1 : 1) * (isAsc ? 1 : -1);
  //    } else {
  //      return (a[designationColonne] < b[designationColonne] ? -1 : 1) * (isAsc ? 1 : -1);
  //    }
  //  });



  //  /* ---------------------------------------------------------------------------------------------------- */console.log(this.colonneSort);
  //  /* ---------------------------------------------------------------------------------------------------- */console.log(this.directionSort);
  //  /* ---------------------------------------------------------------------------------------------------- */console.log(this.sortActive);

  //  /* ---------------------------------------------------------------------------------------------------- */console.log(this.sortedResults);

  //  this.sortedResults = data.sort((a, b) => {


  //    if (this.colonneSort[0] == "manufacturer") {
  //      /* ---------------------------------------------------------------------------------------------------- */console.log("if (this.colonneSort[0] == 'manufacturer') {");
  //      if (a.manufacturer < b.manufacturer) { return -1 * (this.directionSort[0] == "asc" ? 1 : -1); }
  //      if (a.manufacturer > b.manufacturer) { return 1 * (this.directionSort[0] == "asc" ? 1 : -1); }
  //      //return (a.manufacturer < b.manufacturer ? -1 : 1) * (this.directionSort[0] == "asc" ? 1 : -1);
  //    }
  //    if (this.colonneSort[1] == "code") {
  //      /* ---------------------------------------------------------------------------------------------------- */console.log("if (this.colonneSort[1] == 'code') {");
  //      if (a.code > b.code) { return -1 * (this.directionSort[1] == "asc" ? 1 : -1); }
  //      if (a.code < b.code) { return 1 * (this.directionSort[1] == "asc" ? 1 : -1); }
  //      //return (a.code < b.code ? -1 : 1) * (this.directionSort[1] == "asc" ? 1 : -1);
  //    }
  //    if (this.colonneSort[2] == "designation") {
  //      /* ---------------------------------------------------------------------------------------------------- */console.log("if (this.colonneSort[2] == 'designation') {");
  //      if (a.designation > b.designation) { return -1 * (this.directionSort[2] == "asc" ? 1 : -1); }
  //      if (a.designation < b.designation) { return 1 * (this.directionSort[2] == "asc" ? 1 : -1); }
  //      //return (a.designation < b.designation ? -1 : 1) * (this.directionSort[2] == "asc" ? 1 : -1);
  //    }
  //    if (this.colonneSort[3] == "dateFrom") {
  //      /* ---------------------------------------------------------------------------------------------------- */console.log("if (this.colonneSort[3] == 'dateFrom') {");
  //      if (a.dateFrom > b.dateFrom) { return -1 * (this.directionSort[3] == "asc" ? 1 : -1); }
  //      if (a.dateFrom < b.dateFrom) { return 1 * (this.directionSort[3] == "asc" ? 1 : -1); }
  //      //return (a.dateFrom < b.dateFrom ? -1 : 1) * (this.directionSort[3] == "asc" ? 1 : -1);
  //    }
  //    if (this.colonneSort[4] == "dateTo") {
  //      /* ---------------------------------------------------------------------------------------------------- */console.log("if (this.colonneSort[4] == 'dateTo') {");
  //      if (a.dateTo > b.dateTo) { return -1 * (this.directionSort[4] == "asc" ? 1 : -1); }
  //      if (a.dateTo < b.dateTo) { return 1 * (this.directionSort[4] == "asc" ? 1 : -1); }
  //      //return (a.dateTo < b.dateTo ? -1 : 1) * (this.directionSort[4] == "asc" ? 1 : -1);
  //    }
  //    //if (this.colonneSort[5] == "formule") {
  //    //  return (a.formuleNum < b.formuleNum ? -1 : 1) * (this.directionSort[] ? 1 : -1);
  //    //}
  //    if (this.colonneSort[5] == "shadeGuideNum") {
  //      /* ---------------------------------------------------------------------------------------------------- */console.log("if (this.colonneSort[5] == 'shadeGuideNum') {");
  //      if (a.shadeGuideNum > b.shadeGuideNum) { return -1 * (this.directionSort[5] == "asc" ? 1 : -1); }
  //      if (a.shadeGuideNum < b.shadeGuideNum) { return 1 * (this.directionSort[5] == "asc" ? 1 : -1); }
  //      //return (a.shadeGuideNum < b.shadeGuideNum ? -1 : 1) * (this.directionSort[5] == "asc" ? 1 : -1);
  //    }
  //    if (this.colonneSort[6] == "technology") {
  //      /* ---------------------------------------------------------------------------------------------------- */console.log("if (this.colonneSort[6] == 'technology') {");
  //      if (a.technology > b.technology) { return -1 * (this.directionSort[6] == "asc" ? 1 : -1); }
  //      if (a.technology < b.technology) { return 1 * (this.directionSort[6] == "asc" ? 1 : -1); }
  //      //return (a.technology < b.technology ? -1 : 1) * (this.directionSort[6] == "asc" ? 1 : -1);
  //    }
  //    if (this.colonneSort[7] == "popularite") {
  //      /* ---------------------------------------------------------------------------------------------------- */console.log("if (this.colonneSort[7] == 'popularite') {");
  //      if (a.popularite > b.popularite) { return -1 * (this.directionSort[7] == "asc" ? 1 : -1); }
  //      if (a.popularite < b.popularite) { return 1 * (this.directionSort[7] == "asc" ? 1 : -1); }
  //      //return (parseInt(a.popularite.replace("< ", "")) < parseInt(b.popularite.replace("< ", "")) ? -1 : 1) * (this.directionSort[7] == "asc" ? 1 : -1);
  //    }
  //    if (this.colonneSort[8] == "ssCouche") {
  //      /* ---------------------------------------------------------------------------------------------------- */console.log("if (this.colonneSort[8] == 'ssCouche') {");
  //      if (a.ssCouche > b.ssCouche) { return -1 * (this.directionSort[8] == "asc" ? 1 : -1); }
  //      if (a.ssCouche < b.ssCouche) { return 1 * (this.directionSort[8] == "asc" ? 1 : -1); }
  //      //return (a.ssCouche < b.ssCouche ? -1 : 1) * (this.directionSort[8] == "asc" ? 1 : -1);
  //    }
  //    if (this.colonneSort[9] == "region") {
  //      /* ---------------------------------------------------------------------------------------------------- */console.log("if (this.colonneSort[9] == 'region') {");
  //      if (a.region > b.region) { return -1 * (this.directionSort[9] == "asc" ? 1 : -1); }
  //      if (a.region < b.region) { return 1 * (this.directionSort[9] == "asc" ? 1 : -1); }
  //      //return (a.region < b.region ? -1 : 1) * (this.directionSort[9] == "asc" ? 1 : -1);
  //    }

  //    return 0;
  //    //if (a[designationColonne] == b[designationColonne]) return 0;
  //    //if (designationColonne == "popularite") {
  //    //  return (parseInt(a.popularite.replace("< ", "")) < parseInt(b.popularite.replace("< ", "")) ? -1 : 1) * (isAsc ? 1 : -1);
  //    //} else {
  //    //  return (a[designationColonne] < b[designationColonne] ? -1 : 1) * (isAsc ? 1 : -1);
  //    //}

  //  });

  //  /* ---------------------------------------------------------------------------------------------------- */console.log(this.sortedResults);

  //  /* ---------------------------------------------------------------------------------------------------- */console.log("/*---------------------------------*/");
  //  /* ---------------------------------------------------------------------------------------------------- */console.log("");


  //}

}
